<template>
  <div class="content">
   <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item  :to="{ path: '/techPro1' }">技术管理</el-breadcrumb-item>
            <!-- <el-breadcrumb-item  v-if="form.type==1&&groupType==3" :to="{ path: '/noticeEntBuild' }">通知公告</el-breadcrumb-item>
            <el-breadcrumb-item  v-if="form.type==1">修改公告</el-breadcrumb-item>
            <el-breadcrumb-item  v-if="form.type==2&&groupType==2" :to="{ path: '/laws' }">法律法规</el-breadcrumb-item>
            <el-breadcrumb-item  v-if="form.type==2&&groupType==3" :to="{ path: '/lawsBuild' }">法律法规</el-breadcrumb-item>
            <el-breadcrumb-item  v-if="form.type==2">修改法律法规</el-breadcrumb-item> -->
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="build-CURD">
      <!-- <div class="build-bar head-title">
        合肥经开区各在建项目重点人群隔离观察信息表
      </div>-->
      <div class="build-bar" style="padding:10px;height:auto;">
        <!-- <el-input placeholder="请输入工程名称" v-model="search.name" style="margin-left:20px;"></el-input>
        <el-button type="primary" icon="el-icon-search" >查询</el-button>-->
        <!-- <el-button type="primary" class="noIcon" style="margin-left:20px;" @click="resetAdd">添加</el-button> -->
      </div>
      <div class="build-table box-flex">
        <!-- 通知编辑 -->
        <div class="bar-right">
          <el-form ref="form" :model="form" label-width="80px" style="display:flex;flex-wrap:wrap;">
            <div style="width:100%;">
              <el-form-item label="标题">
                <el-input placeholder="请输入标题" v-model="form.title"></el-input>
              </el-form-item>
            </div>
            <div class="components-container">
             <!-- <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              name="img"
              :data='fileUpload'
              :show-file-list="false"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :before-upload="beforeUpload">
             </el-upload> -->
              <quill-editor
                ref="text"
                v-model="form.content"
                class="myQuillEditor"
                :options="editorOption"
              />
              <!-- <el-button type="primary" @click="submit">提交</el-button> -->
            </div>
            <el-form-item>
              <el-button type="primary" @click="createFun">保存修改</el-button>
              <!-- <el-button type="warning" @click="releaseFun" v-if="form.noticeType==''">发布通知</el-button> -->
              <!-- <el-button type="primary" @click="modifyFun" v-if="form.noticeType=='2'">修改通知</el-button>
              <el-button type="warning" @click="fabuFun" v-if="form.noticeType=='2'">发布通知</el-button>
              <el-button type="primary" @click="resetFun" v-if="form.noticeType=='1'">撤回通知</el-button> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'

export default {
 
//   fileUpload:{   //附件上传
//       type:'221',
//     },
    
// serverUrl:base.url + '/upload/uploadPhotosAndThumbnail',
  components: {
    quillEditor
  },
  data() {
    return {
      search: {
        name: '',
      },
      form: {
        title:'',
        type:'1', //公告
        richText:'', //富文本内容
      },
      groupId:'',
      groupType:"",
      editorOption: {},
      createBy:'', 
      dataList:'', 
          }
        },
  mounted() {
    this.form.type = this.$route.params.type
    this.createBy = this.$store.state.user.id;
    this.groupId =  util.session.get('groupId');
    console.log(this.groupId)
    if(this.groupId==""){
      this.$store.commit("setGroupId");
      this.groupId = this.$store.state.groupId;
    }
    if (util.session.get('roleId') == '3') {
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (this.$store.state.roleId == '5') {
      this.groupType = '2'
    }
    this.getData()
  },
  methods: {
   /**获取数据
    * 
    */
      getData() {
      var that = this
      myHttp.getProDocumentation({
       id:this.$route.params.id
      }).then(
        function (resp) {
          if (resp.data.code == '200') {
           var list =resp.data.data.proDocumentation
           that.form = list
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '服务器出错'
          }
        },
        function () {}
      )
    },

    /**
     * 修改
     */
    createFun(e) {
      let that = this
      this.form.updateBy = this.createBy
      this.form.projectId= this.groupId,
      this.form.createBy = this.createBy
      this.form.joinType = this.groupType
      console.log(this.form)
      myHttp.updateProDocumentation(this.form).then(
        function(resp) {
          if (resp.data.code == '200') {
            that.$message.success(resp.data.msg)
            that.$router.go(-1)
          } else {
            that.$message.error(resp.data.msg)
          }
        },
        function() {
          that.$message.error('服务器繁忙，请稍后再试')
        }
      )
    },

  }
}
</script>
<style>
.info {
  border-radius: 10px;
  line-height: 20px;
  padding: 10px;
  margin: 10px;
 
}
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
 
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
   background: #fff;
}
.color-red {
  color: red;
}
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}
.bar-left {
  width: 500px;
  height: 100%;
  overflow: auto;
  border-right: 1px solid #ddd;
}
.bar-right {
  /* width: calc(100% - 500px); */
  height: 100%;
  overflow: auto;
  padding: 20px;
  margin:auto
}
.head-title {
  height: 80px;
  border: 0;
  padding-left: 50px;
  display: flex;
  /* box-shadow: 3px 3px 6px 4px #ddd; */
  font-size: 20px;
  color: #2058d9;
  border-bottom: 10px solid #ecf0f5;
}
.build-table {
  width: 100%;
  height: calc(100% - 70px);
}
.box-flex {
  display: flex;
}
.bar-right .el-form-item__content {
  text-align: left;
}
.el-tabs__header {
  background: #cecece;
  padding: 0 20px;
}
.el-tabs__content {
  height: calc(100% - 55px);
}
.el-tabs__nav-wrap::after {
  background-color: none;
}
.components-container {
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}
.build-bar .noIcon span {
  margin-left: 0;
}
.el-tab-pane {
  height: 100%;
}
.el-form-item__label {
    text-align: left !important;
  
}
</style>